export const getHunterValleyData = () => ({
  name: "Hunter Valley",
  country: "Australie",
  description: "La Hunter Valley est la plus ancienne région viticole d'Australie, fondée en 1825. Cette région est réputée pour ses vins de Sémillon uniques et ses Shiraz élégants, bénéficiant d'un climat subtropical avec des influences océaniques.",
  type: "region",
  mapAreas: [
    { region: "Hunter Valley", x: 55, y: 65, color: "#6d2c7a", size: 5 }
  ],
  statistics: {
    totalArea: "8,000 ha",
    production: "0.6 million hectolitres",
    appellations: "Hunter Valley GI",
    subregions: "3 sous-régions principales",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat subtropical avec étés chauds et humides, hivers doux, influence océanique",
    soil: "Sols volcaniques, argileux, sableux, excellente rétention d'eau",
    viticulture: "Viticulture traditionnelle, vieilles vignes, vendanges manuelles"
  },
  wineStyles: {
    red: "Shiraz élégants et épicés, avec des tanins soyeux et une complexité aromatique",
    white: "Sémillon uniques, vieillissement exceptionnel, notes de miel et de cire",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La Hunter Valley est le berceau de la viticulture australienne, fondée par James Busby en 1825. La région a développé des styles de vins uniques, notamment le Sémillon qui vieillit exceptionnellement bien. Aujourd'hui, elle combine tradition et innovation.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  subregions: {
    "lower-hunter-valley": {
      name: "Lower Hunter Valley",
      description: "Cœur historique de la région, réputé pour ses Sémillon et Shiraz de qualité exceptionnelle.",
      characteristics: {
        climate: "Subtropical, influence océanique",
        soil: "Sols volcaniques et argileux",
        viticulture: "Vieilles vignes, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Sémillon", "Chardonnay", "Verdejo"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "semillon": "Vins blancs uniques, vieillissement exceptionnel",
        "shiraz": "Rouges élégants et épicés"
      },
      foodPairing: "Fruits de mer, poissons, fromages affinés"
    },
    "upper-hunter-valley": {
      name: "Upper Hunter Valley",
      description: "Zone plus élevée, réputée pour ses vins rouges structurés et ses blancs frais.",
      characteristics: {
        climate: "Plus frais, altitude élevée",
        soil: "Sols granitiques et argileux",
        viticulture: "Vignobles modernes, irrigation contrôlée"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sémillon", "Sauvignon Blanc"],
        red: ["Shiraz", "Cabernet Sauvignon", "Merlot"]
      },
      wineStyles: {
        "rouge": "Rouges structurés et équilibrés",
        "blanc": "Blancs frais et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, cuisine traditionnelle"
    },
    "broke-fordwich": {
      name: "Broke Fordwich",
      description: "Zone émergente, connue pour ses vins rouges fruités et ses blancs aromatiques.",
      characteristics: {
        climate: "Méditerranéen, influence continentale",
        soil: "Sols argileux et sableux",
        viticulture: "Vignobles modernes, expérimentation variétale"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Sémillon", "Verdejo"],
        red: ["Shiraz", "Cabernet Sauvignon", "Tempranillo"]
      },
      wineStyles: {
        "rouge": "Rouges fruités et accessibles",
        "blanc": "Blancs aromatiques et frais"
      },
      foodPairing: "Viandes rouges, volailles, cuisine moderne"
    }
  }
}); 